var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseItemGroup',{staticClass:"xyz pl-3",attrs:{"item":_vm.item,"text":"","prepend-icon":_vm.item.icon,"append-icon":"mdi-menu-down"}})}
var staticRenderFns = []

export { render, staticRenderFns }